import { render, staticRenderFns } from "./EnderecoModalManage.vue?vue&type=template&id=4d88aadf&scoped=true"
import script from "./EnderecoModalManage.vue?vue&type=script&lang=js"
export * from "./EnderecoModalManage.vue?vue&type=script&lang=js"
import style0 from "./EnderecoModalManage.vue?vue&type=style&index=0&id=4d88aadf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88aadf",
  null
  
)

export default component.exports